module.exports = __webpack_public_path__ + "static/media/paserg-background-colors.8decb16d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-background-colors.png
// module id = 211
// module chunks = 0